import React, { useEffect, useRef, useState } from 'react'
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import api from '../api';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import { ProgressSpinner } from 'primereact/progressspinner';

const Reports = () => {

    const [loading, setLoading] = useState(false);
    const dt = useRef(null);


    const [totalData, setTotalData] = useState(0);

    const [reportsList, setreportsList] = useState([]);
    const getReports = async () => {
      try {
        setLoading(true);
        const requestData = {
            userid :"admin",
            synceddatetime : "26-03-2025 11:09:29",
            FormCode : "102",
            ApiKey : "kavin",
            AppTypeNo : "3",
            AppVersion : "1.0.0",
            data_source : "W"
        };
        const result = await api.get_Reports(requestData);
          const responseData = result.loged_in_details;
          const slNo = responseData.map((item, index) => ({
                     ...item, slno: index + 1
                 }));
                 setreportsList(slNo);
            setTotalData(result.total_registration_count);

      } catch (error) {
        console.error("Error fetching requested data:", error);
      } finally {
        setLoading(false);
      }
    };
    useEffect(() => {
        getReports();
    }, []);
  
  
    const [globalFilter, setGlobalFilter] = useState('');
  
    const onFilterInputChange = (e) => {
      setGlobalFilter(e.target.value);
    };
    const filteredData = reportsList.filter((role) =>
    Object.values(role).some((value) => {
      if (value === null || value === undefined) {
        return false;
      }
      return value.toString().toLowerCase().includes(globalFilter.toLowerCase());
    })
  );

  const exportToExcel = () => {
    // Define the columns you want to export and their custom headers
    const columnMapping = {
      slno: "Sl no",
      fld_name: "Name",
      fld_registration_date: "Registration Date",
      fld_email: "Email",
      fld_phone_number: "Contact Number"
    };
  
    // Transform the data based on the selected columns
    const excelData = filteredData.map((item) => {
      const transformedItem = {};
      Object.keys(columnMapping).forEach((key) => {
        if (item[key] !== undefined) {
          transformedItem[columnMapping[key]] = item[key];
        }
      });
      return transformedItem;
    });
  
    // Create a worksheet and workbook
    const worksheet = XLSX.utils.json_to_sheet(excelData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Reports");
  
    // Trigger Excel download
    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const data = new Blob([excelBuffer], { type: 'application/octet-stream' });
    saveAs(data, 'Registration Report.xlsx');
  };
  const header = () => {
    return (
      <div className="flex justify-content-between">
             <IconField iconPosition="left">
               <InputIcon className="pi pi-search">
               </InputIcon>
               <InputText value={globalFilter} onChange={onFilterInputChange} placeholder="Search" />
             </IconField>
        <Button
          icon="pi pi-file-excel"
          label="Download Excel"
          style={{background:"#2C2F8C"}}
          onClick={exportToExcel}
        />
      </div>
    );
  };


  return (
    <div className="container">

{loading && (
                    <div className="backdrop">
                        <ProgressSpinner style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }} />
                    </div>
                )}

      <span className="heading-page">Report</span>

      <h4 className='mb-0 mt-5' style={{textAlign:"end"}}>Total Registration : {totalData}</h4>

      <DataTable
                value={filteredData}
                scrollHeight="450px"
                paginator
                rows={20}
                rowsPerPageOptions={[5, 10, 25, 50]}
                header={header}
                ref={dt}
                scrollable
                style={{marginTop:"2rem"}}
              >
                <Column field="slno" header="Sl.No" />
                <Column field="fld_name" header="Name"></Column>
                <Column field="fld_registration_date" header="Register Date"></Column>
                <Column field="fld_email" header="E-mail"></Column>
                <Column field="fld_phone_number" header="Phone Number"></Column>
              </DataTable>
    </div>
  )
}

export default Reports
